module.exports = {
    'core.title': 'Demo core title',
    'ngDro-core.register': 'Register Now',
    'ngDro-core.registerNow': 'Register Now',
    'ngDro-core.remember': 'Remember Me',
    'ngDro-core.log-in' : 'Log In',
    'ngDro-core.login' : 'Login',
    'ngDro-core.italian':'Italian',
    'ngDro-core.english':'English',
    'ngDro-core.log-out' : 'Logout'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/languages/en.js
// module id = 308
// module chunks = 0